import React, { FC, useEffect, useState } from 'react';
import {
  Input,
  Select,
  CheckBox,
  Button,
  TopProgress,
  BackArrow,
} from '../../../../components'
import { useFormik } from 'formik';
import * as yup from 'yup';
import {openstackPlanService} from '../../../../api';
import { useParams, useNavigate } from 'react-router-dom';
import { Container } from './styles';

const CreateEditPlanPage: FC = () => {
  const { planId } = useParams<{ planId?: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const [currencies, setCurrencies] = useState<any[]>([]);
  const [initialValues, setInitialValues] = useState({
    name: '',
    currency: '',
    is_default: false,
  });

  useEffect(() => {
    setLoadingOptions(true);
    openstackPlanService.getPlanCreateOptions().then((res: any) => {
      setCurrencies(
        (res.data.currencies || []).map((c: any) => ({
          label: c.code,
          value: c.code,
          ...c,
        }))
      );
      setLoadingOptions(false);
    });
  }, []);

  useEffect(() => {
    if (planId) {
      setLoading(true);
      openstackPlanService.getPlanById(planId).then((res: any) => {
        setInitialValues({
          name: res.data.name || '',
          currency: res.data.currency || '',
          is_default: !!res.data.is_default,
        });
        setLoading(false);
      });
    }
  }, [planId]);

  const validationSchema = yup.object().shape({
    name: yup.string().required('Required'),
    currency: yup.string().required('Required'),
    is_default: yup.boolean(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        if (planId) {
          await openstackPlanService.updatePlanById(planId, values);
        } else {
          await openstackPlanService.createPlan(values);
        }
        navigate(-1);
      } catch (e) {
        // handle error, e.g. show notification
      } finally {
        setLoading(false);
      }
    },
  });

  if (loadingOptions || loading) return <TopProgress loading={true} />;

  return (
    <Container style={{ maxWidth: 400, margin: '0 auto', padding: 24 }}>
      <BackArrow
        customStyles={{ marginBottom: '10px' }}
        fallbackPath={planId
          ? `/settings/openstack-plans/plan/${planId}`
          : '/settings/openstack-plans'}
      />
      <h2 style={{ marginBottom: 24 }}>{planId ? 'Edit OpenStack Plan' : 'Create OpenStack Plan'}</h2>
      <form onSubmit={formik.handleSubmit}>
        <Input
          title="Name"
          fieldName="name"
          value={formik.values.name}
          handleChange={formik.handleChange}
          errors={formik.errors}
          touched={formik.touched}
          onBlur={formik.handleBlur}
          required
          placeholder="Enter plan name"
        />
        <Select
          title="Currency"
          data={currencies}
          selectedValue={formik.values.currency}
          onChange={(val: any) => formik.setFieldValue('currency', val?.value || val)}
          errors={formik.errors}
          touched={formik.touched}
          fieldName="currency"
          required
        />
        <CheckBox
          title="Is Default"
          value={formik.values.is_default}
          onChange={() => formik.setFieldValue('is_default', !formik.values.is_default)}
        />
        <div style={{ marginTop: 32, display: 'flex', gap: 12 }}>
          <Button
            title="Cancel"
            variant="stroke"
            onClick={() => navigate(-1)}
            customStyles={{ width: 120 }}
            size="display"
          />
          <Button
            title={planId ? 'Update' : 'Create'}
            variant="primary"
            loading={loading}
            customStyles={{ width: 120 }}
            size="display"
            onClick={() => formik.handleSubmit()}
          />
        </div>
      </form>
    </Container>
  );
};

export default CreateEditPlanPage;
